import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Usuários'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Clientes'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Grupos de trabalho'
, [ TEXT.UI_MENU_JOBS          ]: 'Tarefas'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'Masterkeying'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Gerar'
, [ TEXT.UI_BUTTON_NEW         ]: 'Nova'
, [ TEXT.UI_BUTTON_OK          ]: 'Ok'
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Cancelar'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Salve'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Login'
, [ TEXT.UI_BUTTON_SEND        ]: 'Mandar'


, [ TEXT.UI_EMAIL              ]: 'Email'
, [ TEXT.UI_ROLE               ]: 'Função'
, [ TEXT.UI_USERNAME           ]: 'Usuário'
, [ TEXT.UI_NAME               ]: 'Nome'
, [ TEXT.UI_DATE               ]: 'Data'
, [ TEXT.UI_ADDR               ]: 'Endereço'
, [ TEXT.UI_DESC               ]: 'Descrição'
, [ TEXT.UI_PRICE              ]: 'Preço'
, [ TEXT.UI_NO_DATA            ]: 'Sem dados'
, [ TEXT.UI_MACHINES           ]: 'Máquinas'
, [ TEXT.UI_USERS              ]: 'Usuários'
, [ TEXT.UI_DATE_FORMAT        ]: 'DD/MM/YYYY' // ES - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Sair'
, [ TEXT.UI_MKS_TYPE           ]: 'Tipo MKS'
, [ TEXT.UI_KEY_APP            ]: 'Uso de chave'
, [ TEXT.UI_CLIENT             ]: 'Cliente'
, [ TEXT.UI_FILE               ]: 'Arquivo'
, [ TEXT.UI_SELECT_FILE        ]: 'Selecione o arquivo'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Nome de usuário'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Nuvem'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Senha'



, [ TEXT.ARE_YOU_SURE          ]: 'Você tem certeza?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Usuário / nuvem ou senha incorretos'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Usuário / nuvem ou senha incorretos'
, [ TEXT.ERROR_INTERNAL        ]: 'Erro do Servidor Interno'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Acesso negado'
, [ TEXT.ERROR_UNKNOWN         ]: 'Houve um erro, e isso é tudo o que sabemos'

, [ TEXT.PAGE_NOT_FOUND        ]: 'Página não encontrada'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'Novo grupo de trabalho'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Editar grupo de trabalho'
, [ TEXT.WORKGROUPS_NAME       ]: 'Nome'


, [ TEXT.USERS_NEW_TITLE       ]: 'Novo usuário'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Editar usuário'


, [ TEXT.MACHINE_TYPE          ]: 'Tipo de máquina'
, [ TEXT.MACHINE_NUM_JOBS      ]: 'Tarefas'
, [ TEXT.MACHINE_NAME          ]: 'Máquina'


, [ TEXT.CLIENT_NEW_TITLE      ]: 'Novo cliente'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Editar cliente'
, [ TEXT.CLIENT_ADDRESS        ]: 'Endereço'
, [ TEXT.CLIENT_CONTACT        ]: 'Contato'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'Email'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Telefone'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Fax/Tlf'
, [ TEXT.CLIENT_SURNAMES       ]: 'sobrenome'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Aniversário'
, [ TEXT.CLIENT_NOTES          ]: 'Notas'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Nome do filtro'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Endereço do filtro'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Filtrar contato'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Endereço'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'Cidade'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'Província'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'Código postal'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'País'


, [ TEXT.MACHINES_NEW          ]: 'Nova Máquina'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Número de série'

, [ TEXT.JOB_EDIT_TITLE        ]: 'Editar tarefa'
, [ TEXT.JOB_NEW_TITLE         ]: 'Nova tarefa'
, [ TEXT.JOB_KEY_TYPE          ]: 'Tipo de chave'
, [ TEXT.JOB_NUM_KEYS          ]: 'Quantidade'
, [ TEXT.JOB_MACHINE           ]: 'Máquina'
, [ TEXT.JOB_STATUS            ]: 'Estado'
, [ TEXT.JOB_DATE              ]: 'Data'
, [ TEXT.JOB_QUANTITY          ]: 'Nova quantidade'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Filtrar por estado'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Filtrar clientes'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Filtrar Máquina'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'Filtrar por chave'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Filtrar por data'

, [ TEXT.KEY_MASTERING_LAUNCH   ]: 'Lançamento'
, [ TEXT.KEY_MASTERING_LAUNCH_N ]: 'Lançamento ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE ]: 'Carregar Masterkeying'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: '{num} chaves serão criadas. Você tem certeza?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: '{num} trabalho(s) foram criados'
, [ TEXT.KEY_MASTERING_NAME               ]: 'Nome Masterkeying'

, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION ]: 'Esqueceu a senha?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE ]: 'Enviou instruções de descanso para'
, [ TEXT.LOGIN_SLOGAN                   ]: 'The first cloud based key duplication app'
, [ TEXT.LOGIN_QUALITY_POINTS           ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>
<ul class="login-sell-points">
  <li>Registe as duplicações das chaves realizadas aos seus clientes</li>
  <br>
  <li>Guarde os dados sem risco de perdê-los e com acesso desde qualquer lugar</li>
  <br>
  <li>Atualizações automáticas</li>
</ul>
`

, [ TEXT.LEGAL_TOS_TEXT              ]: 'Aviso legal'
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Política de privacidade'
, [ TEXT.LEGAL_MODEL_TEXT            ]: 'Modelo de acordo'
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/pt/legal_notice_pt.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/pt/privacy_policy_pt.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/pt/model_pt.docx'

, [ TEXT.KEY_MODEL                   ]: 'Chave'
, [ TEXT.KEY_SERIES                  ]: 'Séries'
, [ TEXT.KEY_CODE                    ]: 'Código'
, [ TEXT.KEY_DATA_SHEET              ]: 'Ficheiro'
, [ TEXT.KEY_BITING                  ]: 'Corte'
, [ TEXT.KEY_APPLICATION             ]: 'Aplicação'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'PENDENTE'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'CANCELADO'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'COMPLETO'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'EM PROCESSAMENTO'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMIN'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'MANAGER'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'USER'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'CARRO'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'CASA'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'SEGURANÇA'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'CADEADO'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'NÃO ESPECIFICADO'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Por favor, preencha os campos obrigatórios em vermelho'
}

export default ES ;
